module.exports = "/fast-coin/img/coin/anim/in/coin_in_022.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/in/coin_in_022.png
// module id = 2292
// module chunks = 5